/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-key */
import * as React from 'react';
import './index.css';
import clsx from 'clsx';
import { hitKeeta3UIRefreshStrategy } from '../../common/ABStrategy';
import { DropOffOptionData } from './type';
import { DROP_OFF_TYPE, DROP_OFF_SPOT_TYPE, DROP_OFF_SOURCE_TYPE } from './constant';
import DropOffLX from './statistics';
import { ORDER_BIZLINE } from '../OrderCommon/constant';
import i18nClient from '../../pages/order/order_confirm_golden/i18nConstant';
import faceToDeliveryImg from '../../assets/order/face_to_delivery.png';
import assignedPlaceImg from '../../assets/order/assigned_place.png';
import faceToDeliveryGlobalImg from '../../assets/order/order_confirm/face_to_delivery_confirm_global.png';
import assignedPlaceGlobalImg from '../../assets/order/order_confirm/assigned_place_confirm_global.png';
import selectedImg from '../../assets/order/drop_off_option_selected.png';
import unSelectedImg from '../../assets/order/drop_off_option_unselected.png';

interface IProps {
  sourceType?: number;
  dropOffType?: number;
  dropOffSpotType?: number;
  addressId?: number;
  bizLine?: string;
  optionTitleFontSize?: number;
  onSelectedOptionDataCallback: (optionData: DropOffOptionData) => void;
  isNewStyle?: boolean; // 是否是开放地图新样式
}

interface IState {
  dropOffData: any;
}

export default class DropOffView extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    // 若当前没有选择交付类型，则默选当面交付
    const { dropOffType = DROP_OFF_TYPE.HAND_TO_ME } = props;
    const dropOffData = this.initDropOffData(dropOffType);
    this.state = {
      dropOffData,
    };

    // 默选逻辑
    this.onSelectedDropOffOptionCallback();
  }

  /**
     * 初始化数据
     * @returns
     */
  initDropOffData = (dropOffType: DROP_OFF_TYPE) => {
    const showGlobalV3Ui = hitKeeta3UIRefreshStrategy();
    return {
      options: [
        {
          title: i18nClient.getText('drop_off_option1'),
          type: DROP_OFF_TYPE.HAND_TO_ME,
          selected: dropOffType === DROP_OFF_TYPE.HAND_TO_ME,
          spotRequire: false,
          spotName: i18nClient.getText('address_when_can_not_reach_titile'),
          spotList: this.initDropOffSpotListData(DROP_OFF_TYPE.HAND_TO_ME),
          icon: showGlobalV3Ui ? faceToDeliveryGlobalImg : faceToDeliveryImg
        },
        {
          title: i18nClient.getText('drop_off_option2'),
          type: DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT,
          selected: dropOffType === DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT,
          spotRequire: true,
          spotName: i18nClient.getText('drop_off_subtitle1'),
          spotList: this.initDropOffSpotListData(DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT),
          icon: showGlobalV3Ui ? assignedPlaceGlobalImg : assignedPlaceImg
        }
      ],
      inputTitle: i18nClient.getText('add_more_detail'),
    };
  }

  /**
     * 初始化收餐地点数据
     * @param initDropOffType
     * @returns
     */
  initDropOffSpotListData = (initDropOffType: DROP_OFF_TYPE) => {
    const spotList = [
      {
        title: i18nClient.getText('address_when_can_not_reach_option1'),
        selected: false,
        type: DROP_OFF_SPOT_TYPE.MY_DOOR,
      },
      {
        title: i18nClient.getText('address_when_can_not_reach_option2'),
        selected: false,
        type: DROP_OFF_SPOT_TYPE.LOBBY,
      },
      {
        title: i18nClient.getText('address_when_can_not_reach_option3'),
        selected: false,
        type: DROP_OFF_SPOT_TYPE.FRONT_DESK,
      },
    ];
    if (initDropOffType === DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT) {
      const other = {
        title: i18nClient.getText('address_when_can_not_reach_option4'),
        selected: false,
        isRequired: true,
        type: DROP_OFF_SPOT_TYPE.OTHER,
      };
      spotList.push(other);
    }

    this.selectDefaultSpot(spotList, initDropOffType);

    return spotList;
  }

  // 默选交付地点选项
  selectDefaultSpot = (spotList: any[], initDropOffType: DROP_OFF_TYPE) => {
    if (spotList?.length === 0) {
      return;
    }
    const { dropOffType, dropOffSpotType } = this.props;
    const selectedItem = spotList.find((item) => item.type === dropOffSpotType);
    if (initDropOffType === DROP_OFF_TYPE.HAND_TO_ME) {
      // 默选选中上次交付地点
      if (dropOffType === initDropOffType && selectedItem) {
        selectedItem.selected = true;
      }
    } else if (initDropOffType === DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT) {
      // 若当前没有选中的地点，则默选交付地点为家门口
      if (dropOffType === initDropOffType && selectedItem) {
        selectedItem.selected = true;
      } else {
        const spotItem = spotList.find((item) => item.type === DROP_OFF_SPOT_TYPE.MY_DOOR);
        if (spotItem) {
          spotItem.selected = true;
        }
      }
    }
  }

  /**
     * 选择收餐方式
     * @param item
     */
  onClickOptionItem = (item) => {
    if (item.selected) {
      return;
    }
    const { dropOffData } = this.state;
    const currentSelectedOptionItem = dropOffData?.options?.find((item) => item?.selected === true);
    if (currentSelectedOptionItem) {
      currentSelectedOptionItem.selected = false;
    }
    item.selected = true;
    this.setState({
      dropOffData,
    }, () => {
      this.onSelectedDropOffOptionCallback();
    });
    // 交付选项点击埋点
    this.onLxReportOptionItemMC(item);
  }

  /**
     * 选择地点
     * @param item
     */
  onClickSpotItem = (item) => {
    const { dropOffData } = this.state;
    const currentSelectedOptionItem = dropOffData?.options?.find((item) => item?.selected === true);
    const currentSelectedSpotItem = currentSelectedOptionItem?.spotList?.find((item) => item?.selected === true);
    // 取消当前选中项
    if (currentSelectedSpotItem) {
      currentSelectedSpotItem.selected = false;
    }
    // 当面交付，地点可复选
    if (currentSelectedOptionItem?.type === DROP_OFF_TYPE.HAND_TO_ME) {
      if (currentSelectedSpotItem?.type !== item.type) {
        item.selected = true;
      }
    } else if (currentSelectedOptionItem?.type === DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT) { // 放到指定地点
      if (item.selected) {
        return;
      }
      item.selected = true;
    }
    this.onLxReportSpotItemMC(item);
    this.setState({
      dropOffData,
    }, () => {
      this.onSelectedDropOffOptionCallback();
    });
  }

  /**
     * 选择交付方式信息回调
     */
  onSelectedDropOffOptionCallback = () => {
    const { dropOffData } = this.state;
    const { onSelectedOptionDataCallback } = this.props;
    const selectedOptionItem = dropOffData?.options?.find((item) => item.selected === true);
    const { spotList = [] } = selectedOptionItem || {};
    const selectedSpotItem = spotList?.find((item) => item.selected === true);
    // 如果没有交付类型，则默认当面交付兜底
    const selectedDropOffType = selectedOptionItem?.type ?? DROP_OFF_TYPE.HAND_TO_ME;
    // 如果没有交付地点，当面交付选的地点用未选择兜底，放到指定地点用家门口兜底
    let selectedDropOffSpotType = selectedSpotItem?.type ?? DROP_OFF_SPOT_TYPE.UNSELECTED;
    if (selectedDropOffType === DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT) {
      selectedDropOffSpotType = selectedSpotItem?.type ?? DROP_OFF_SPOT_TYPE.MY_DOOR;
    }
    if (onSelectedOptionDataCallback) {
      const optionData = {
        dropOffType: selectedDropOffType,
        dropOffSpotType: selectedDropOffSpotType,
        isRequireInputText: selectedSpotItem?.isRequired,
      };
      onSelectedOptionDataCallback(optionData);
    }
  }

  /**
     * 点击交互选项灵犀埋点
     * @param item
     */
  onLxReportOptionItemMC = (item) => {
    const cid = this.getCurrentPageCID();
    const { addressId, bizLine } = this.props;
    const val = {
      address_id: addressId ?? '-999',
      drop_off_option: item.type ?? '-999',
      biz_line: bizLine || ORDER_BIZLINE.KFOOD,
    };
    DropOffLX.dropOffOptionItemMC(cid, val);
  }

  /**
     * 地点灵犀曝光埋点
     */
  onLxReportSpotItemMV = (item) => {
    if (item._hasReport) {
      return;
    }
    item._hasReport = true;
    const { dropOffData } = this.state;
    const optionsList = dropOffData?.options || [];
    const currentOptionItem = optionsList?.find((item) => item.selected === true);
    const currentDropOffType = currentOptionItem?.type;
    if (currentDropOffType === DROP_OFF_TYPE.HAND_TO_ME) {
      this.onLxReportCantReachItemMV(item);
    } else if (currentDropOffType === DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT) {
      this.onLxReportDesignatedItemMV(item);
    }
  }

  /**
     * 地点灵犀点击埋点
     */
  onLxReportSpotItemMC = (item) => {
    const { dropOffData } = this.state;
    const optionsList = dropOffData?.options || [];
    const currentOptionItem = optionsList?.find((item) => item.selected === true);
    const currentDropOffType = currentOptionItem?.type;
    if (currentDropOffType === DROP_OFF_TYPE.HAND_TO_ME) {
      this.onLxReportCantReachItemMC(item);
    } else if (currentDropOffType === DROP_OFF_TYPE.LEAVE_AT_DESIGNATED_SPOT) {
      this.onLxReportDesignatedItemMC(item);
    }
  }

  /**
     * 当面交付-联系不上按钮曝光
     * @param item
     */
  onLxReportCantReachItemMV = (item) => {
    const cid = this.getCurrentPageCID();
    const val = this.getSpotItemCommonLxParams(item);
    DropOffLX.dropOffCantReachItemMV(cid, val);
  }

  /**
     * 当面交付-联系不上按钮曝光
     * @param item
     */
  onLxReportCantReachItemMC = (item) => {
    const cid = this.getCurrentPageCID();
    const val = this.getSpotItemCommonLxParams(item);
    DropOffLX.dropOffCantReachItemMC(cid, val);
  }

  /**
     * 当面交付-联系不上按钮曝光
     * @param item
     */
  onLxReportDesignatedItemMV = (item) => {
    const cid = this.getCurrentPageCID();
    const val = this.getSpotItemCommonLxParams(item);
    DropOffLX.dropOffDesignatedItemMV(cid, val);
  }

  /**
     * 当面交付-联系不上按钮曝光
     * @param item
     */
  onLxReportDesignatedItemMC = (item) => {
    const cid = this.getCurrentPageCID();
    const val = this.getSpotItemCommonLxParams(item);
    DropOffLX.dropOffDesignatedItemMC(cid, val);
  }

  /**
     * 放到指定地点-地点选择
     * @returns
     */
  getSpotItemCommonLxParams = (item) => {
    const { addressId, bizLine } = this.props;
    const spotCodeInfo = {
      [DROP_OFF_SPOT_TYPE.MY_DOOR]: 0,
      [DROP_OFF_SPOT_TYPE.LOBBY]: 1,
      [DROP_OFF_SPOT_TYPE.FRONT_DESK]: 2,
      [DROP_OFF_SPOT_TYPE.OTHER]: 3,
    };
    const val = {
      address_id: addressId ?? '-999',
      delivery_spot: spotCodeInfo[item.type] ?? '-999',
      biz_line: bizLine || ORDER_BIZLINE.KFOOD,
    };
    return val;
  }

  /**
     * 获取页面CID
     */
  getCurrentPageCID = () => {
    const { sourceType = DROP_OFF_SOURCE_TYPE.CONFIRM } = this.props;
    const cid = sourceType === DROP_OFF_SOURCE_TYPE.CONFIRM ? 'c_waimai_c_overseas_ftj7f1qa' : 'c_waimai_c_overseas_dmr0kb7p';
    return cid;
  }

  render(): React.ReactNode {
    const { dropOffData } = this.state;
    const { optionTitleFontSize = 14, isNewStyle = false } = this.props;
    const optionItemWidth = (Mach.env.screenWidth - (isNewStyle ? 26 : 40)) / 2.0;
    const optionItemHeight = isNewStyle ? 45 : 44;
    const inputTitleClass = isNewStyle ? 'input-title-v2' : 'input-title';
    const spotItemContainerClass = isNewStyle ? 'spot-item-container-v2' : 'spot-item-container';
    const spotItemSelectedClass = isNewStyle ? 'spot-item-selected-v2' : 'spot-item-selected';
    const spotItemNormalClass = isNewStyle ? 'spot-item-normal-v2' : 'spot-item-normal';
    const spotItemTitleClass = isNewStyle ? 'spot-item-title-v2' : 'spot-item-title';
    const optionsList = dropOffData?.options || [];
    const currentOptionItem = optionsList?.find((item) => item.selected === true);
    const { spotName = '', spotList = [] } = currentOptionItem || {};
    const currentSelectedSpotItem = spotList?.find((item) => item?.selected === true);
    return (
      <view className="container">
        <view className="option-container">
          {optionsList.map((item) => (
            <view
              className="option-item-container"
              style={{ width: optionItemWidth, height: optionItemHeight }}
              onClick={() => {
                this.onClickOptionItem(item);
              }}
            >
              <image className="option-item-icon" src={item.icon} autoRTL />
              <text
                className="option-item-title"
                style={{ fontSize: optionTitleFontSize, color: isNewStyle ? '#000000' : '#222222' }}
                content={item.title}
              />
              <view className="option-item-switch-container">
                <image className="option-item-switch-icon" src={item.selected ? selectedImg : unSelectedImg} />
              </view>
            </view>
          ))}
        </view>
        <view className="spot-title-container">
          <text className={inputTitleClass} content={spotName} />
          {currentOptionItem?.spotRequire ? <text className="require-text" content="*" /> : null}
        </view>
        <view className="spot-container" key={spotList} style={{ marginBottom: isNewStyle ? 26 : 20 }}>
          {spotList?.map((spotItem) => (
            <view
              className={clsx(
                spotItemContainerClass,
                spotItem?.selected ? spotItemSelectedClass : spotItemNormalClass
              )}
              key={`${currentOptionItem?.title}-${spotItem?.title}`}
              onClick={() => {
                this.onClickSpotItem(spotItem);
              }}
              onLayout={(frame) => {
                this.onLxReportSpotItemMV(spotItem);
              }}
            >
              <text className={spotItemTitleClass} content={spotItem?.title || ''} />
            </view>
          ))}
        </view>
        <view className="input-info-container">
          <text className={inputTitleClass} content={dropOffData?.inputTitle || ''} />
          {currentSelectedSpotItem?.isRequired ? <text className="require-text" content="*" /> : null}
        </view>
      </view>
    );
  }
}
